export default "__VITE_ASSET__fvUl8Le1__"